/*import {ReactComponent as ReactLogo} from '../assets/images/logo.svg';*/
import icon from '../assets/images/fiscaliza_borda.png';

export const AppTopbarLogo = (props) => {

    return (
        <div className={props.class}>
            <div className="logo-app">                
                {/*<ReactLogo/>*/}
                <img  src={icon} style={{height: '40px'}} alt= {props.nomeSistema}/>
            </div>
            <div className="titulo-app">
                <div className="titulo-sistema">
                    {props.nomeSistema}
                </div>
            </div>
        </div>
    );
};
